export default __webpack_public_path__ + "static/media/Source2_Candidate_upload_Rich_File_QA.2a454a53.xlsx";